import React from 'react';
import ArticleStatusSelectProperties from "./ArticleStatusSelectProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import SelectOption from "../../../ui_components/Select/SelectOption";
import Select from "../../../ui_components/Select/Select";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import ArticleStatus from "../../../entities/ArticleStatus";

const ArticleStatusSelect: React.FC<ArticleStatusSelectProperties> = ({
                                                                        selected,
                                                                        onChange,
                                                                        disabled,
                                                                        fullWidth = false,
                                                                        className = '',

                                                                    }) => {

    const i18n = useI18nContext();

    const opt = [
        new SelectOption(i18n.translate("ACTIVE"), ArticleStatus.FOR_SALE, 'Disponible para la venta', CheckCircleIcon),
        new SelectOption(i18n.translate("INACTIVE"), ArticleStatus.INACTIVE, 'No disponible para la venta', CancelIcon),
    ]

    const selectedOption = opt.find(t => t.value === selected);

    const onStatusChange = (option: SelectOption) => {
        onChange(option.value as ArticleStatus)
    }

    return (
        <Select
            className={className}
            disabled={disabled}
            fullWidth={fullWidth}
            label={i18n.translate("STATUS")}
            placeholder={i18n.translate("STATUS_PLACEHOLDER")}
            selected={selectedOption}
            icon={ToggleOnIcon}
            onChange={onStatusChange}
            elements={opt}
        />
    )
}


export default ArticleStatusSelect;
